// This entity has been generated, do not change its content, your changes might get lost. You CAN modify the rest of the file.
enum RefundApprovalType {
  FactualAuditor = "FACTUAL_AUDITOR",
  CommandOperator = "COMMAND_OPERATOR",
  ChiefAccountant = "CHIEF_ACCOUNTANT",
}
export default RefundApprovalType;
